export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_842_N_A': 'N/A'
};
